import { createBlueprint as t } from "@made-people/blueprint";
const a = t({
  slots: {
    base: "relative flex bg-black/20 text-white rounded-lg @[98vw]:rounded-none overflow-clip",
    tagsWrapper: "flex gap-4",
    tag: "text-xs uppercase tracking-widest bg-black/20 px-2 py-1 rounded-lg",
    contentWrapper: "flex flex-col gap-3 z-10 p-4 lg:p-6 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:p-8 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:md:p-14 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:lg:p-16 gap-4 lg:gap-6 box-content",
    ctasWrapper: "flex flex-wrap gap-2",
    contentShadow: "",
    headingWrapper: "",
    body: "",
    link: "",
    background: "w-full h-full absolute left-0 top-0 object-cover data-[is-video]:z-10",
    backgroundSplitLeft: "w-1/2 h-full absolute left-0 top-0 object-cover",
    backgroundSplitRight: "w-1/2 h-full absolute left-1/2 top-0 object-cover"
  },
  variants: {
    colorTheme: {
      white: {
        base: "text-white"
      },
      black: {
        base: "text-black"
      },
      yellow: {
        base: ""
      }
    },
    stickyContent: {
      true: {
        base: "!overflow-[unset]",
        contentWrapper: "sticky bottom-0 left-0 right-0"
      }
    },
    contentPosition: {
      "top-left": {
        base: "justify-start items-start",
        contentWrapper: "justify-start items-start text-left"
      },
      "top-center": {
        base: "justify-center items-start",
        contentWrapper: "justify-center items-center text-center"
      },
      "top-right": {
        base: "justify-end items-start",
        contentWrapper: "justify-end items-end text-right"
      },
      "center-left": {
        base: "justify-start items-center",
        contentWrapper: "justify-start items-start text-left"
      },
      "center-center": {
        base: "justify-center items-center",
        contentWrapper: "justify-center items-center text-center"
      },
      "center-right": {
        base: "justify-end items-center",
        contentWrapper: "justify-end items-end text-right"
      },
      "bottom-left": {
        base: "justify-start items-end",
        contentWrapper: "justify-start items-start text-left"
      },
      "bottom-center": {
        base: "justify-center items-end",
        contentWrapper: "justify-center items-center text-center"
      },
      "bottom-right": {
        base: "justify-end items-end",
        contentWrapper: "justify-end items-end text-right"
      }
    },
    dim: {
      none: {
        base: "brightness-100"
      },
      subtle: {
        background: "brightness-95"
      },
      medium: {
        background: "brightness-90"
      },
      strong: {
        background: "brightness-75"
      }
    },
    size: {
      portrait: {
        base: "aspect-portrait"
      },
      tall: {
        base: "aspect-tall"
      },
      square: {
        base: "aspect-square"
      },
      landscape: {
        base: "aspect-landscape"
      },
      wide: {
        base: "aspect-wide"
      },
      "ultra-wide": {
        base: "aspect-ultra-wide"
      },
      panorama: {
        base: "aspect-panorama"
      },
      auto: {
        base: "aspect-[var(--aspect-ratio-mobile)] md:aspect-[var(--aspect-ratio-tablet)] lg:aspect-[var(--aspect-ratio-desktop)]"
      },
      "full-height-reveal": {
        base: "w-full h-full max-h-[calc(100vh-100px)] aspect-[unset]"
      }
    },
    blur: {
      sm: {
        base: "",
        background: ""
      },
      md: {
        base: "",
        background: ""
      },
      lg: {
        base: "",
        background: ""
      }
    },
    tagColor: {
      white: {
        tag: "bg-white text-black"
      },
      black: {
        tag: "bg-black text-white"
      }
    },
    ctaPlacement: {
      content: {
        ctasWrapper: ""
      },
      "split-centered": {
        ctasWrapper: "data-[split-image=true]:absolute data-[split-image=true]:inset-0 data-[split-image=true]:!grid data-[split-image=true]:grid-cols-2 data-[split-image=true]:place-items-center data-[split-image=true]:gap-4"
      }
    },
    splitImage: {
      true: {
        base: "",
        contentWrapper: "",
        ctasWrapper: ""
      },
      false: {
        base: "",
        contentWrapper: "",
        ctasWrapper: ""
      }
    }
  },
  defaultVariants: {
    size: { initial: "portrait", lg: "wide" },
    contentPosition: "bottom-left",
    stickyContent: "true",
    dim: "none",
    splitImage: "false",
    ctaPlacement: "content"
  }
});
export {
  a as bannerStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
